import dayjs from "dayjs";

export const canRescheduleAccepted = (influencer: {
  tabStatus?: string;

  applicationDate?: {
    date?: string;
    hour?: string;
  };
}) => {
  if (!influencer) return false;
  const status = String(influencer?.tabStatus ?? "").toLowerCase();
  if (status !== "accepted") return false;

  const app = influencer?.applicationDate;
  if (!app) return false;

  const baseDate = app.date ? dayjs(app.date) : null;
  if (!baseDate || !baseDate.isValid()) return false;

  return !baseDate.isBefore(dayjs(), "day");
};
